





































import DeviceRoleMapMixin from '@/features/core/components/mixins/device-role-map';
import { formatMetricName, formatMetricValue } from '@/features/core/util/metric-formatters';
import { normalizeMetricPoint } from '@/features/core/util/metrics';
import { BooleanProp, ObjectProp } from '@/util/prop-decorators';
import { Component, Mixins } from 'vue-property-decorator';
import { AppManagerTreeNodeGroundPlanViewSpotFragment } from './__generated__/AppManagerTreeNodeGroundPlanViewSpotFragment';

type FormattedMetrics = {
  name: string;
  value: string | null;
};

@Component
export default class GroundPlanSpotPlacement extends Mixins(DeviceRoleMapMixin) {
  @ObjectProp()
  private readonly spot!: AppManagerTreeNodeGroundPlanViewSpotFragment;

  @BooleanProp()
  private readonly disabled!: boolean;

  @BooleanProp()
  private readonly dragging!: boolean;

  @BooleanProp()
  private readonly clickTooltip!: boolean;

  private get icon(): string | undefined {
    const { sm, md } = this.deviceRoleMap[this.spot.role]?.icons ?? {};

    return sm ?? md;
  }

  private get formattedMetrics(): { name: string; value: string | null; time: string | null }[] {
    return this.spot.metrics
      .map(({ name, latest }) => {
        const latestMetricPoint = normalizeMetricPoint(latest);
        let time: string | null = null;
        if (
          latestMetricPoint &&
          typeof latestMetricPoint === 'object' &&
          'time' in latestMetricPoint &&
          latestMetricPoint.time
        ) {
          const date = new Date(latestMetricPoint.time);
          time = `${date.toLocaleDateString('de-DE')} ${date.toLocaleTimeString('de-DE')}`;
        }
        return {
          name,
          value: latestMetricPoint ? formatMetricValue(name, latestMetricPoint.value) : null,
          time,
        };
      })
      .filter(({ value }) => value !== null);
  }

  private formatMetricName = formatMetricName;
}
